import React, { useState } from 'react';
import { AnnouncementBar } from './AnnouncementBar';

const DISMISS_KEY = 'rebrandBannerDismissed';
const NEW_URL = 'https://6love.app';

// The banner nudges visitors on the legacy domain to move to 6love.app, so it
// keys off the runtime hostname rather than the build-time brand. A single
// local-dev build serves both tennis-local.henkhaus.org and 6love-local.app, so
// a build-time brand check would wrongly show this on the 6love host too.
const onLegacyDomain = (): boolean =>
  typeof window !== 'undefined' &&
  window.location.hostname.includes('henkhaus.org');

const RebrandBanner: React.FC = () => {
  const [dismissed, setDismissed] = useState<boolean>(
    () => localStorage.getItem(DISMISS_KEY) === '1'
  );

  if (!onLegacyDomain() || dismissed) return null;

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, '1');
    setDismissed(true);
  };

  return (
    <AnnouncementBar
      tone="dark"
      onClose={dismiss}
      action={{ label: 'Go to 6love.app', href: NEW_URL }}
      style={{ zIndex: 20 }}
    >
      <strong style={{ fontWeight: 600 }}>Tennis Team Manager is becoming 6-love.</strong>{' '}
      Same app, same login — new home at 6love.app.
    </AnnouncementBar>
  );
};

export default RebrandBanner;
